import type {
  GetRepartitionFormationParAgenceViewModel,
  RepartitionFormationViewModel,
  PaginationOffsetResponseModel_RepartitionFormationTableData,
} from '@/lib/types'
import baseRepository from '@/repository/BaseRepository.ts'
import { getStoredEndDate, getStoredStartDate } from '@/lib/localStorage.ts'

export default {
  async getInfoCardData(): Promise<RepartitionFormationViewModel[]> {
    const url = await baseRepository.buildUrl(`api/widgets/card-repartition-formations-annee/?date=${getStoredStartDate()}`)
    return baseRepository.fetchData<RepartitionFormationViewModel[]>(url)
  },

  async getRepartitionData(): Promise<GetRepartitionFormationParAgenceViewModel[]> {
    const url = await baseRepository.buildUrl(`api/widgets/card-repartition-formations-par-agence/?date=${getStoredStartDate()}`)
    return baseRepository.fetchData<GetRepartitionFormationParAgenceViewModel[]>(url)
  },

  async getTableData(
    skip: number,
    take: number,
  ): Promise<PaginationOffsetResponseModel_RepartitionFormationTableData> {
    const params = {
      offset: skip.toString(),
      limit: take.toString(),
      date: getStoredStartDate()
    }
    const url = await baseRepository.buildUrl('api/widgets/card-detail-repartitions-formations/', params)
    return baseRepository.fetchData<PaginationOffsetResponseModel_RepartitionFormationTableData>(url)
  },
  async downloadExcel(): Promise<void> {
    await baseRepository.downloadExcelFile(
      `api/widgets/card-details-clients/${getStoredEndDate()}/excel`,
      `clients_${getStoredEndDate()}.xlsx`,
    )
  },
}
